import { Link } from "@mui/material";
import Button from "@mui/material/Button";
import OtpInput from "react-otp-input";

const OPTContent = ({ otp, setOtp, handleSubmit, requestNewOTP }) => {
  return (
    <>
      {otp?.email && (
        <p className="sp-auth__hint">
          Código enviado para <strong>{otp?.email}</strong>
        </p>
      )}

      <OtpInput
        containerStyle="sp-auth__otp"
        value={otp?.otp}
        onChange={(value) => setOtp({ ...otp, otp: value })}
        numInputs={4}
        renderInput={(props) => <input {...props} aria-label="Dígito do código" />}
      />

      <Button className="sp-auth__submit" variant="contained" onClick={handleSubmit} disabled={otp?.otp?.length < 4}>
        Confirmar
      </Button>

      <p className="sp-auth__resend">
        Não recebeste o e-mail? Vê na pasta de spam ou{" "}
        <Link component="button" type="button" onClick={requestNewOTP}>
          reenvia o código
        </Link>
        .
      </p>
    </>
  );
};

export default OPTContent;
